import React from 'react';
import { Navbar } from '../components/Navbar';
import { TrustBar } from '../components/TrustBar';
import { RelatedFeatures } from '../components/RelatedFeatures';
import { Footer } from '../components/Footer';
import { EnrichmentHero } from '../components/local-business-enrichment/EnrichmentHero';
import { EnrichmentSearch } from '../components/local-business-enrichment/EnrichmentSearch';
import { EnrichmentWorkflow } from '../components/local-business-enrichment/EnrichmentWorkflow';
import { EnrichmentProductTour } from '../components/local-business-enrichment/EnrichmentProductTour';
import { EnrichmentFields } from '../components/local-business-enrichment/EnrichmentFields';
import { EnrichmentDemo } from '../components/local-business-enrichment/EnrichmentDemo';
import { EnrichmentComparison } from '../components/local-business-enrichment/EnrichmentComparison';
import { EnrichmentPricing } from '../components/local-business-enrichment/EnrichmentPricing';
import { EnrichmentUseCases } from '../components/local-business-enrichment/EnrichmentUseCases';
import { EnrichmentFAQ } from '../components/local-business-enrichment/EnrichmentFAQ';
import { EnrichmentCta } from '../components/local-business-enrichment/EnrichmentCta';
import { BookOpenIcon, DatabaseIcon, ScaleIcon, BriefcaseIcon } from 'lucide-react';
const enrichmentFeatures = [{
  title: 'Doctor contacts database',
  description: 'Access medical practices and physicians.',
  href: 'https://openmart.com/data/doctors',
  cta: 'Explore doctors',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Property management contacts database',
  description: 'Discover property managers with verified details.',
  href: 'https://openmart.com/data/property-management',
  cta: 'Explore property managers',
  type: 'Database',
  color: 'purple' as const,
  icon: DatabaseIcon
}, {
  title: 'Using the Openmart API to fetch data',
  description: 'Integrate the Openmart API into your application.',
  href: 'https://openmart.com/product-tutorials/using-the-openmart-api-to-fetch-data',
  cta: 'Read tutorial',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Clay + Openmart integration',
  description: 'Combine Clay and Openmart to enrich lead lists.',
  href: 'https://openmart.com/product-tutorials/clay-openmart',
  cta: 'View guide',
  type: 'Tutorial',
  color: 'blue' as const,
  icon: BookOpenIcon
}, {
  title: 'Fortune 100 case study',
  description: 'How a Fortune 100 company enriches local business data at scale with Openmart.',
  href: 'https://www.openmart.com/case-study/fortune-100',
  cta: 'Read case study',
  type: 'Case Study',
  color: 'green' as const,
  icon: BriefcaseIcon
}, {
  title: 'Openmart vs Apollo',
  description: 'Compare coverage, accuracy, and pricing.',
  href: 'https://openmart.com/comparison/openmart-vs-apollo',
  cta: 'See comparison',
  type: 'Comparison',
  color: 'orange' as const,
  icon: ScaleIcon
}];
export function LocalBusinessEnrichment() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-100 selection:text-blue-900" data-id="element-6903">
      <Navbar data-id="element-6904" />
      <main data-id="element-6905">
        <EnrichmentHero data-id="element-6906" />
        <TrustBar data-id="element-6907" />
        <EnrichmentSearch data-id="element-6908" />
        <EnrichmentWorkflow data-id="element-6909" />
        <EnrichmentProductTour data-id="element-6910" />
        <EnrichmentFields data-id="element-6911" />
        <EnrichmentDemo data-id="element-6912" />
        <EnrichmentComparison data-id="element-6913" />
        <EnrichmentPricing data-id="element-6914" />
        <EnrichmentUseCases data-id="element-6915" />
        <EnrichmentFAQ data-id="element-6916" />
        <RelatedFeatures features={enrichmentFeatures} data-id="element-6917" />
        <EnrichmentCta data-id="element-6918" />
      </main>
      <Footer data-id="element-6919" />
    </div>;
}